const role = {
  ADMIN: 'admin',
  USER: 'user'
}

export default role
